<template>
  <div class="vant-table" :class="tablestyle">
    <table cellspacing="0" style="width: 100%" align="left" class="table">
      <tr v-if="showoperate">
        <th class="th" v-for="(item, index) in option.column" :key="index">
          {{ item.label }}
        </th>
        <th v-if="showoperate" class="th">操作</th>
      </tr>
      <tr v-for="(item, index) in tableData" :key="index" class="list-tr">
        <td v-for="(context, i) in option.column" :key="i" class="van-ellipsis">
          {{ item[context.tableDataprop] }}
        </td>
        <td v-if="showoperate" @click="openDetail(item)" class="blue-btn">
          详情
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: "TableVant",
  props: {
    name: {
      type: String,
      default: "",
    },
    showoperate: {
      type: Boolean,
      default: false,
    },
    tablestyle: {
      type: String,
      default: "",
    },
    tableData: {
      type: Array,
      default: [],
    },
    option: {
      type: Object,
      default: {},
    },
  },
  created() {},
  methods: {
    openDetail(obj) {
      this.$emit("father", obj);
    },
  },
};
</script>

<style scoped lang="less">
.table {
  font-size: 20px;
  color: #666666;
  border-radius: 0.185185rem;
}
.th {
  background-color: #EFEFEF;
  text-align: left;
  padding-left: 20px;
}
.list-tr {
  border-bottom: solid 1px #efefef;
  /deep/td {
    padding-left: 20px;
    word-break: break-all;
    word-wrap: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
td {
  text-align: left;
}
.blue-btn {
  color: #277fff;
  cursor: pointer;
}
</style>
